export const ALBUM_DEFAULT_IMAGE_PATH = '/images/bg-landing.png';
export const ALBUM_DESCRIPTION_FALLBACK = 'Galéria (k)lubovňa SL';
export const ALBUM_DESCRIPTION_MAX_LENGTH = 200;
export const ALBUM_SITE_TITLE = '(k)lubovňa SL';
